<div class="page">
  <br>
  <header class="header-page">
    <div class="logo">
      <img src="../../../assets/images/icons/TrendItApps No BG 1 (1).png" alt="Trendit Apps Logo" style="width: 15vw;">
    </div>
    <nav class="button-apps">
      <div class="apps-section" (mouseleave)="toggleDropdown(false)" (mouseover)="toggleDropdown(true)">
        <div class="app button"><strong>Nos applications</strong></div>
        <div class="drop-list" *ngIf="isDropdownVisible">
          <div class="worklog-button">
            <a href="https://worklog.fr/" class="worklog-button" target="_blank" rel="noopener noreferrer">
              <strong>Worklog</strong>
            </a>
          </div>
          
        </div>
      </div>
      <div class="line"></div>
      
        <a href="https://trendit.fr/contact/"  class="client button" target="_blank" rel="noopener noreferrer">
          <strong>Contact</strong>
        </a>
      
    </nav>
    <img src="../../../assets/images/icons/Hamburger_icon.svg.png" alt="" class="hamburger-icon" (click)="handleNavBar()">
  </header>
  
  <section class="hero-section">
    <div class="hero-content">
      <h1>Notre Marketplace</h1>
      <p>Bienvenue sur notre marketplace, votre destination complète pour des solutions informatiques innovantes et efficaces.</p>     
    </div>
    <div class="explore">
      <p>Explorez nos produits</p>
      <a (click)="scrollToProducts()"><img src="/assets/images/icons/arrow-down.svg" alt="Explore"></a>
    </div>     
  </section>

</div>
<div class="nav-menu" *ngIf="showNavMenu">
  <img src="../../../assets/images/icons/x-thin.svg" alt="" (click)="handleNavBar()">
  <p class="apps-text" (click)="handleApps()">Nos applications</p>
  <a class="apps-view" href="https://worklog.fr/" target="_blank" rel="noopener noreferrer">Worklog</a>
  <a href="https://trendit.fr/contact/" target="_blank" rel="noopener noreferrer">Contact</a>
</div>
